// removed by extract-text-webpack-plugin
module.exports = {"root":"FilterForm__root__3QMZb","contentWrapper":"FilterForm__contentWrapper__arX-1","buttonsWrapper":"FilterForm__buttonsWrapper__3QxKU","clearButton":"FilterForm__clearButton__2RDNP","cancelButton":"FilterForm__cancelButton__2WjQa","submitButton":"FilterForm__submitButton__3PLhj"};


//////////////////
// WEBPACK FOOTER
// ./src/forms/FilterForm/FilterForm.css
// module id = 1719
// module chunks = 0